import { render, staticRenderFns } from "./CreateOffice.vue?vue&type=template&id=58bc1c43&scoped=true"
import script from "./CreateOffice.vue?vue&type=script&lang=js"
export * from "./CreateOffice.vue?vue&type=script&lang=js"
import style0 from "./CreateOffice.vue?vue&type=style&index=0&id=58bc1c43&prod&scoped=true&lang=css"
import style1 from "./CreateOffice.vue?vue&type=style&index=1&id=58bc1c43&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc1c43",
  null
  
)

export default component.exports